/** Elements marked with this attribute (support widget, floating buttons) are left out of captures. */
export const SCREENSHOT_IGNORE_ATTRIBUTE = "data-screenshot-ignore";

/**
 * Captures what the user is currently seeing (the visible part of the page)
 * as a JPEG, leaving out the support widget itself. html2canvas is loaded on
 * demand so it doesn't weigh on the initial bundle.
 */
export async function captureCurrentScreen(): Promise<Blob> {
  const { default: html2canvas } = await import("html2canvas");
  const pageBackground = getComputedStyle(document.body).backgroundColor || getComputedStyle(document.documentElement).backgroundColor;

  const canvas = await html2canvas(document.body, {
    x: window.scrollX,
    y: window.scrollY,
    width: window.innerWidth,
    height: window.innerHeight,
    windowWidth: document.documentElement.clientWidth,
    windowHeight: window.innerHeight,
    scale: Math.min(window.devicePixelRatio || 1, 1.5),
    useCORS: true,
    logging: false,
    backgroundColor: pageBackground && pageBackground !== "rgba(0, 0, 0, 0)" ? pageBackground : "#f8fafc",
    ignoreElements: (element) => element.hasAttribute(SCREENSHOT_IGNORE_ATTRIBUTE)
  });

  const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, "image/jpeg", 0.82));
  if (!blob) {
    throw new Error("Não foi possível gerar a imagem da tela.");
  }
  return blob;
}
